import React, { useState, useEffect } from 'react';
import { FormattedMessage } from "react-intl"
import { useNavigate, Link, Form } from "react-router-dom";

import { useDispatch, useSelector } from 'react-redux'

import Subtitle from '../components/UI/Subtitle'
import BaseInput from '../components/UI/BaseInput'
import PrimaryButton from '../components/UI/PrimaryButton'

import { login } from '../redux/actions/userActions'

let errorLoginClass = 'text-center py-2 bg-red-100 font-bold text-md text-red-500 border-2 border-rose-600 rounded-xl'

const Login = () => {

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    const navigate = useNavigate()
    const dispatch = useDispatch()

    const userLogin = useSelector(state => state.userLogin)
    const { userDetails, loading, error } = userLogin

    useEffect(() => {
        if (userDetails?.status === "ok") {
            navigate('/app/dashboard')
        }
    }, [userDetails, navigate])

    const handleSubmit = async (e) => {
        e.preventDefault();
        dispatch(login(email, password))
    }

    return (
        <div className="p-4 flex flex-col items-center mt-20">
            <form onSubmit={handleSubmit} className="flex flex-col gap-4" style={{ minWidth: '300px' }}>
                <Subtitle><FormattedMessage id="app.login.promptLogin" defaultMessage="Sign in here" /></Subtitle>
                <BaseInput value={email}
                    onChange={(e) => setEmail(e.currentTarget.value)}
                    placeholder='Email' />
                <BaseInput type='password'
                    value={password}
                    onChange={(e) => setPassword(e.currentTarget.value)}
                    placeholder='Password' />

                {(!loading && (error === 'Wrong email or password' || error === 'User not present or not allowed') ? <p className={errorLoginClass}><FormattedMessage id="app.login.wrongCredentials" defaultMessage="Wrong email or password credentials" /></p> : '')}
                {(!loading && (error === 'User still not authorized') ? <p className={errorLoginClass}><FormattedMessage id="app.login.userNotAuthorized" defaultMessage="User still not authorized" /></p> : '')}

                <PrimaryButton>
                    <FormattedMessage id="app.login.submitLogin" defaultMessage="Login" />
                </PrimaryButton>
                <span className='text-center font-bold text-green-900 underline'>
                    <Link to="/app/password-reset">
                        <FormattedMessage id="app.login.forgotPassword" defaultMessage="Forgot your password?" />
                    </Link>
                </span>
                <span className='text-center'>
                    <p><FormattedMessage id="app.login.notYetRegistered" defaultMessage="" /></p>
                </span>

                <Link to="/app/register">
                    <button className='w-full inline-block bg-blue-900 text-center text-white font-medium rounded-xl p-2' type='submit'>
                        <FormattedMessage id="app.login.signUp" defaultMessage="Sign Up" />
                    </button></Link>
            </form>
        </div>
    );
};

export default Login;